import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../../theme/css/theme.css";

export const cancelButtonStyle = style({
  position: "absolute",
  top: `calc(50% - ${rem(16)})`,
  left: `calc(100% + ${theme.spacings.xs})`,
});

export const fieldContainerStyle = style({
  pointerEvents: "auto",
});

export const fieldAnimationWrapperStyle = style({
  position: "relative",
  transform: "translate(-50%, 0%)",
});
